import { Button, Stack } from '@mui/material';

interface ListItemProps {
  active?: boolean;
  onClickCallback?: () => void;
  children?: React.ReactNode;
}

export default function ListItem({
  active = false,
  onClickCallback = () => {},
  children,
}: Readonly<ListItemProps>) {
  return (
    <Stack component='li'>
      <Button
        variant='text'
        onClick={() => onClickCallback()}
        sx={{
          fontWeight: active ? 700 : 400,
          marginBottom: 0,
          paddingX: 0,
          paddingY: 0.5,
          justifyContent: 'left',
          lineHeight: '150%',
          color: active ? 'primary.main' : 'text.secondary',
          textDecoration: 'none',
          textAlign: 'left',
          width: '100%',
          '&:hover': {
            textDecoration: 'underline',
            backgroundColor: 'transparent',
          },
        }}
      >
        {children}
      </Button>
    </Stack>
  );
}
